import React, { useEffect, useState } from "react"
import { Box, Button, Paper, TextField, Typography } from "@material-ui/core"
import OpenInNewIcon from "@material-ui/icons/OpenInNew"
import { useSnackbar } from "../../../utils/notificacoes"
import { obterPagSeguro } from "../../../services/integracaoParceiros"
import useLoadingStore from "../../../stores/LoadingStore"
import { useIntegracaoStyles } from "../../../utils/integracaoParceirosStyles"

export function IntegracaoPagSeguroForm() {
    const classes = useIntegracaoStyles()
    const { enqueueSnackbar } = useSnackbar()
    const setLoading = useLoadingStore(s => s.setLoading)

    const [tokenLoja, setTokenLoja] = useState("")
    const [urlAutorizacao, setUrlAutorizacao] = useState("")

    const alertStart = (msg: string, tipo: "success" | "error" | "info") =>
        enqueueSnackbar(msg, { variant: tipo })

    useEffect(() => {
        const carregar = async () => {
            const autorizacao = localStorage.getItem("chaveSistema")
            if (!autorizacao) return
            setLoading(true)
            try {
                const res = await obterPagSeguro(autorizacao)
                if ("retornoErro" in res) {
                    alertStart(res.mensagem || "Erro ao carregar integração", "error")
                } else {
                    setTokenLoja(res.tokenLoja ?? "")
                    setUrlAutorizacao(res.urlAutorizacao ?? "")
                }
            } finally {
                setLoading(false)
            }
        }
        carregar()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleAutorizar = () => {
        if (!urlAutorizacao) {
            alertStart("URL de autorização indisponível.", "error")
            return
        }
        window.open(urlAutorizacao, "_blank", "noopener,noreferrer")
    }

    return (
        <Box className={classes.container}>
            <Box className={classes.content}>
                <Typography variant="h5" className={classes.titleText}>
                    Integração PagSeguro
                </Typography>

                <Paper className={classes.configCard}>
                    <Box className={classes.cardHeader}>
                        <Typography variant="h6" className={classes.cardHeaderTitle}>
                            Parâmetros PagSeguro
                        </Typography>
                    </Box>
                    <Box className={classes.cardContent}>
                        <TextField
                            label="Token da Loja"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={tokenLoja}
                            disabled
                            helperText="O token é gerado automaticamente ao concluir a autorização com o PagSeguro."
                        />

                        <Box mt={3}>
                            <Button
                                className={classes.saveButton}
                                variant="contained"
                                startIcon={<OpenInNewIcon />}
                                onClick={handleAutorizar}
                            >
                                Solicitar autorização para integração
                            </Button>
                        </Box>
                    </Box>
                </Paper>
            </Box>
        </Box>
    )
}
